import TaskHistoryPage from "./TaskHistoryPage";

export default TaskHistoryPage;